// extracted by mini-css-extract-plugin
module.exports = {"text":"LagnateikningarForm-module--text--15kFl","error":"LagnateikningarForm-module--error--phlLx","errorTextarea":"LagnateikningarForm-module--errorTextarea--u7SbX"};